import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TopBarComponent implements OnInit {
   
    private subscription: Subscription[] = [];
    public data: string = '';
    headerToolsEnabled : Boolean = false;
    headerToolsList = [];

    constructor(private _dataService : DataService) {
        _dataService.headerToolsEnabled.subscribe(data=>{
            this.headerToolsEnabled = data;
        });
        _dataService.headerToolsList.subscribe(data=>{
            console.log(data);
            this.headerToolsList = data;
        });
    }

    ngOnInit() {}

    ngAfterViewInit(): void {
        //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
        //Add 'implements AfterViewInit' to the class.
       // this._dataService.SetCode(this.topbar.nativeElement.innerHTML);
    }

}


// WEBPACK FOOTER //
// ./src/app/headers/top-bar/top-bar.component.ts